<script setup lang="ts">
import { useToolbarHeight } from '@/composables/useToolbarHeight'
import { useThemeVars } from 'naive-ui'
import TeleportWrapperComponent from './TeleportWrapperComponent.vue'

defineProps({
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String
  }
})

const themeVars = useThemeVars()
const { setHeight } = useToolbarHeight()
const target = ref<HTMLElement | null>()
let resizeObserver: ResizeObserver | null = null

onMounted(() => {
  target.value = document.getElementById('toolbar-teleport-target')
})

watch(target, (element) => {
  resizeObserver?.disconnect()
  resizeObserver = null

  if (!element) return

  resizeObserver = new ResizeObserver(([el]) => {
    nextTick(() => {
      setHeight(el.contentRect.height)
    })
  })

  resizeObserver.observe(element)
})

onUnmounted(() => {
  resizeObserver?.disconnect()
})
</script>

<template>
  <TeleportWrapperComponent v-if="target" :to="target">
    <div class="flex flex-col gap-2 w-full">
      <div class="flex items-center gap-4 p-5">
        <div>
          <slot name="breadcrumb"></slot>
          <slot name="title">
            <Transition name="fade">
              <div v-if="title !== ''" class="text-xl font-bold">
                {{ title }}
              </div>
              <div v-else class="will-change-auto" style="line-height: normal;">
                {{ title }}
              </div>
            </Transition>
          </slot>
        </div>
        <div class="text-neutral-500 self-end pb-0.5">
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </div>
        <div class="ml-auto flex items-center gap-2">
          <slot name="extra"></slot>
        </div>
      </div>
      <div
        v-if="$slots.extension"
        class="p-5"
        :style="{ backgroundColor: themeVars.actionColor }"
      >
        <slot name="extension" />
      </div>
    </div>
  </TeleportWrapperComponent>
</template>
